const baseRoute = "v1/carpetEntry";
const TYPE = "CARPET_ENTRY";

const request = (payload) => (api) => ({ type: TYPE, payload: payload(api) });

export const searchEntries = (page, size, filters = {}) => request((api) => api.post(`${baseRoute}/search`, { page, size, filters }));

export const entryCounts = (filters = {}) => request((api) => api.post(`${baseRoute}/counts`, { filters }));

export const carpetByRef = (ref) => request((api) => api.get(`${baseRoute}/by-ref/${encodeURIComponent(ref)}`));

export const checkInEntries = (lines) => request((api) => api.post(`${baseRoute}/check-in`, { lines }));

export const checkOutEntries = (items) => request((api) => api.post(`${baseRoute}/check-out`, { items }));

export const setEntryCleaned = (entryId, cleaned) => request((api) => api.put(`${baseRoute}/cleaned`, { entryId, cleaned }));

export const saveEntryBox = (entryId, storageBox) => request((api) => api.put(`${baseRoute}/storage-boxes`, { entryId, storageBox }));

export const fetchEntriesForJob = (clientId, jobId) => {
  const query = jobId ? `?jobId=${jobId}` : "";
  return request((api) => api.get(`${baseRoute}/for-job/${clientId}${query}`));
};
